import React from "react";
import InPressArticleItemCardBox
    from "@/src/components/journal-site/home/in-press-articles/in-press-article/mui-custom/in-press-article-card-box/in-press-article-card-box";
import ArticleCover
    from "@/src/components/journal-site/home/in-press-articles/in-press-article/mui-custom/article-cover/article-cover";
import {faFeatherPointed, faFileLines, faFolderBookmark} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Box, Typography} from "@mui/material";
import NextLink from "next/link";
import Link from "@mui/material/Link";
import ArticleTitle
    from "@/src/components/journal-site/home/in-press-articles/in-press-article/mui-custom/article-title/article-title";
import ArticleAuthors from "@/src/components/journal-site/common/article/mui-custom/article-authors/article-authors";
import ArticleAuthorsList from "@/src/components/journal-site/common/article/article-authors-list/article-authors-list";
import ArticleInformation
    from "@/src/components/journal-site/common/article/mui-custom/article-information/article-information";
import DownloadBox from "@/src/components/journal-site/common/article/mui-custom/article-information/download-box";
import {TITLE_ALLOWED_TAGS} from "@/src/constant/constant";
import ArticleList from "@/src/_types/Article/article-list";
import {stripHTMLTags} from "@/src/utils/strip-html-tags";

interface ArticleProps {
    article: ArticleList;
    number: number;
}

const InPressArticle: React.FC<ArticleProps> = ({article, number}) => {

    return (
        <InPressArticleItemCardBox>
            <ArticleCover>
                <Typography className={'label-number'} component={'label'}>
                    {number}
                </Typography>
                <FontAwesomeIcon
                    className={'icon'}
                    icon={faFileLines}
                />
            </ArticleCover>

            <Box sx={{
                paddingX: '1.5rem',
                lineHeight: '1.25'
            }}>
                <ArticleTitle
                    component={'h3'}>
                    <Link
                        component={NextLink}
                        href={article.href}
                    >
                        {stripHTMLTags(article.title, TITLE_ALLOWED_TAGS)}
                    </Link>
                </ArticleTitle>

                <ArticleAuthors
                    sx={{
                        marginBottom: 0,
                    }}
                >
                    <FontAwesomeIcon className={'green'} icon={faFeatherPointed}/>
                    <ArticleAuthorsList authors={article.authors}/>
                </ArticleAuthors>

                <ArticleInformation>
                    <FontAwesomeIcon
                        className={'brown'}
                        style={{
                            marginRight: '.25rem',
                        }}
                        icon={faFolderBookmark}
                    />

                    <Typography
                        sx={{
                            color: 'inherit',
                            fontSize: '.8rem',
                            textTransform: 'capitalize',
                        }}
                        component={'span'}>
                        {article.document_type}
                    </Typography>

                    {article.desired_issue && article.issue_id !== article.desired_issue.id && (
                        <>
                            <Typography sx={{
                                color: 'inherit',
                                marginX: '.5rem',
                                fontSize: '.8rem',
                            }}>
                                |
                            </Typography>

                            <Typography sx={{
                                color: 'inherit',
                                fontSize: '.8rem',
                            }}>
                                {article.proof_status} {'\u00A0'}
                                scheduled for {'\u00A0'}
                                {article.desired_issue.volume_name},
                                ({article.desired_issue.name})
                            </Typography>
                        </>
                    )}

                    {article.pdf_file && (
                        <>
                            <Typography sx={{
                                color: 'inherit',
                                marginX: '.5rem',
                                fontSize: '.8rem',
                            }}>
                                |
                            </Typography>

                            <DownloadBox style={{
                                fontSize: '1.5em'
                            }} href={article.pdf_file}/>
                        </>
                    )}
                </ArticleInformation>

            </Box>
        </InPressArticleItemCardBox>
    );
}

export default InPressArticle;
